export function convertEnoviaToDiagram(enoviaJson) {
  if (!enoviaJson || !enoviaJson.data || !enoviaJson.data.length)
    return { nodes: [], edges: [], nodeById: {} };

  const nodes = [];
  const nodeById = {};
  const edges = [];

  const tasks = enoviaJson.data[0].relateddata?.tasks || enoviaJson.data || [];
  
  processTasks(tasks, null, nodes, nodeById, edges, 0);

  const uniqueEdges = dedupeEdges(edges);

  return { nodes, edges: uniqueEdges, nodeById };
}

export function processTasks(tasks, parentId, nodes, nodeById, edges, depth = 0) {
  const tasksArr = Array.isArray(tasks) ? tasks : [tasks];
  tasksArr.forEach(task => walk(task, parentId, nodes, nodeById, edges, depth));
}

function walk(task, parentId, nodes, nodeById, edges, depth) {
  const t = task || {};
  const id = getId(t) || Math.random().toString(36).slice(2, 9);

  let totalFloat = 0;
  if (t.dataelements?.totalFloat) {
    totalFloat = parseFloat(t.dataelements.totalFloat) || 0;
  }

  const title = (t.dataelements && (t.dataelements.title || t.dataelements.name)) || t.title || "";
  const subtitle = t.type || (t.dataelements && t.dataelements.nlsType) || "";
  const status = (t.dataelements && (t.dataelements.status || t.dataelements.status)) || "";
  const maturity = t.state || t.currentState || t.dataelements?.currentState || t.dataelements?.state || t.dataelements?.Maturity || "";

  const assignees = Array.isArray(t.relateddata?.assignees)
    ? t.relateddata.assignees.map((a) => a.dataelements?.fullname || "").filter(Boolean)
    : [];

  const childrenArr = getChildrenArray(t);
  const childrenIds = childrenArr.map((c) => {
    const cid = getId(c);
    if (cid) return cid;
    const temp = Math.random().toString(36).slice(2, 9);
    c.__tempId = temp;
    return temp;
  });

  const node = {
    id,
    title,
    subtitle,
    status,
    maturity,
    assignees,
    dueDate: formateDate(t.dataelements?.dueDate || ""),
    rawDueDate: t.dataelements?.dueDate || "",
    rawActualFinishDate: t.dataelements?.actualFinishDate || "",
    startDate: formateDate(t.dataelements?.estimatedStartDate || ""),
    width: 220,
    height: 100,
    raw: t,
    totalFloat: totalFloat,
    parentId,
    childrenIds,
    hasChildren: childrenIds.length > 0 || t.dataelements?.isSummaryTask === "TRUE" || t.isSummaryTask === "TRUE",
    isInitial: !parentId,
    hierarchyDepth: depth,
  };

  nodes.push(node);
  nodeById[id] = node;

  if (parentId) {
    edges.push({ from: parentId, to: id, type: "hierarchy" });
  }

  if (Array.isArray(t.relateddata?.predecessors)) {
    t.relateddata.predecessors.forEach((pred) => {
      const pid = getId(pred);
      if (pid) edges.push({ from: pid, to: id, type: "dependency" });
    });
  }

  childrenArr.forEach((child) => walk(child, id, nodes, nodeById, edges, depth + 1));
}

function formateDate(d) {
  if (!d) return "";
  const date = new Date(d);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

function getChildrenArray(task) {
  if (Array.isArray(task.children)) return task.children;
  if (Array.isArray(task.relateddata?.children)) return task.relateddata.children;
  if (Array.isArray(task.relateddata?.tasks)) return task.relateddata.tasks;
  if (Array.isArray(task.relateddata?.subTasks)) return task.relateddata.subTasks;
  return [];
}

function getId(t) {
  return t?.id || t?.identifier || (t?.dataelements && t.dataelements.objectId) || null;
}

function dedupeEdges(edges) {
  const seen = new Set();
  const uniqueEdges = [];
  edges.forEach((e) => {
    const key = `${e.from}=>${e.to}#${e.type}`;
    if (!seen.has(key)) {
      seen.add(key);
      uniqueEdges.push(e);
    }
  });
  return uniqueEdges;
}